module.exports = __webpack_public_path__ + "1eb7a893589ddce89d81cdb22a356660.ttf";